import { CurrencyPipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as d3 from 'd3';
import* as _ from 'lodash';
import moment from 'moment';

@Component({
  selector: 'app-cluster-stacked-bar-chart',  
  templateUrl: './cluster-stacked-bar-chart.component.html',
  styleUrls: ['./cluster-stacked-bar-chart.component.scss']
})
export class ClusterStackedBarChartComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<any>();
  @ViewChild('stackAreaBarContainer', { static: true }) stackAreaBarContainer!: ElementRef;
  isVisible:boolean = true;
  @Input('props')  props:any = {};
  @Input('chartData')  chartData:any = [];
  @Input('childChartData')  childChartData:any = [];
  @Input('isFullscreen')  isFullscreen:any = false;
  @Input('config')  config:any;
  smallChartConfig:any
  smallBarChartData:any 
  loader:boolean=false
  divId = "stackedAreaBar"; 
  tooltip = "d3ClusterStackedBarTooltip";
  currentVisibleData: any = [];
  moment = moment;
  isTooltip = false;
  toolTipValue:any = {};
  dataTurn: any
  height: any = 0
  mytooltipData:any;
  arrowVisible:boolean=false;
  //sider Variables
  private sliderSize = 300;
  private handleRadius = 6;
  private currentMin = 0;
  private currentMax = 100;
  private margins = {left:10,top:20}
  private orientation = 'vertical';
  constructor(private currency: CurrencyPipe) { }

  ngOnInit(): void {
     this.divId = this.divId + this?.['config']?.list_of_api;
      this.tooltip = this.tooltip + this?.['config']?.list_of_api;
    // this.initiateCharts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['chartData']?.currentValue != changes?.['chartData']?.previousValue) {
      // this.divId = this.divId + changes['config'].currentValue?.list_of_api;
      // this.tooltip = this.tooltip + changes['config'].currentValue?.list_of_api;
      // setTimeout(() => {
        this.backarrow()
        // this.plotChart();
      // }, 200); 
    }
     if (changes?.['props']?.currentValue != changes?.['props']?.previousValue) {
        // this.backarrow()
      this.plotChart();
    }
    if (!changes?.['isFullscreen']?.firstChange && changes?.['isFullscreen']?.currentValue != changes?.['isFullscreen']?.previousValue && this.isVisible ) {
      this.loader=true
      setTimeout(() => {
            d3.select('#svg_' + this.divId).remove();
            this.initiateCharts();
            this.plotChart();
            this.loader=false
          }, 100);
    }
  }

  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2');
  }  

  detailChart(myData:any,staticColor:any){
    // debugger
    this.loader=true
    const data:any = [];
    let loopData:any = this.props.staticColor ? staticColor: this.props.barFill
    for(let obj in loopData) {
      let object = {
        name: obj,
        color: staticColor[obj],
        key: obj,
        value: myData[obj],
        date:myData['period'],
        period:myData['date']
      }
      if( object.value != undefined){
        data.push(object)}
    }
    this.smallBarChartData = this.childChartData.filter((item: any) =>
     item[this.props.subGroupName]=== data[0].key &&
      moment(item.month_end_date).isSame(moment(data[0].date), 'day')
  );
  this.smallBarChartData = _.orderBy( this.smallBarChartData, ['no_of_patients'], ['desc']);
    this.arrowVisible =true
    this.isVisible=false
    data['status']=  (this.config.list_of_api==100706)? this.childChartData[0].patient_status :undefined
    this.smallChartConfig= data
    this.loader=false
  // console.log(data);
  }

  private showTooltip(myType: any, myData: any, myX: any, myY: any, chartWidth: any, chartHeight: any,staticColor:any): void {
    // console.log(myData);
    // debugger
    const data:any = [];
  let loopData:any = this.props.staticColor ? staticColor: this.props.barFill
    for(let obj in loopData) {
      let object = {
        name: obj,
        color:staticColor[obj],// this.props.barFill[obj],
        key: obj,
        value: myData[obj]
      }
     if( object.value != undefined){
      data.push(object)}
    }
    myData['data'] = data;
    this.mytooltipData = myData
    this.height = 0
    this.dataTurn = 0
    this.height = chartHeight - myY
    this.dataTurn = chartWidth - myX
    // if (this.isFullscreen == true) {
      if (this.height < 200) {
        d3.select(`#${this.tooltip}`)
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('bottom', (this.height - 60) + 'px')
          .style('top', 'unset')
      }
      else if (this.height > 200) {
        d3.select(`#${this.tooltip}`)
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('top', (myY + 30) + 'px')
          .style('bottom', 'unset')
      }
      if (this.dataTurn < 350) {
        d3.select(`#${this.tooltip}`)
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('right', (this.dataTurn + 20) + 'px')
          .style('left', 'unset')
      }
      else if (this.dataTurn > 350) {
        d3.select(`#${this.tooltip}`)
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('left', (myX + 25) + 'px')
          .style('right', 'unset')
      }
      this.isTooltip = true
    // } 
    // else {
    //   if (this.height < 200) {
    //     d3.select(`#${this.tooltip}`)
    //       .style('visibility', 'visible')
    //       .style('position', 'absolute')
    //       .style('bottom', (this.height +  60) + 'px')
    //       .style('top', 'unset')
    //   }
    //   else if (this.height > 200) {
    //     d3.select(`#${this.tooltip}`)
    //       .style('visibility', 'visible')
    //       .style('position', 'absolute')
    //       .style('top', (myY + 60) + 'px')
    //       .style('bottom', 'unset')
    //   }
    //   if (this.dataTurn <350) {
    //     d3.select(`#${this.tooltip}`)
    //       .style('visibility', 'visible')
    //       .style('position', 'absolute')
    //       .style('right', (this.dataTurn + 166) + 'px')
    //       .style('left', 'unset')
    //   }
    //   else if (this.dataTurn >350) {
    //     d3.select(`#${this.tooltip}`)
    //       .style('visibility', 'visible')
    //       .style('position', 'absolute')
    //       .style('left', (myX - 90) + 'px')
    //       .style('right', 'unset')
    //   }
    //   this.isTooltip = true
    // }
  }

  private hideTooltip(myType: any): void {
    d3.select(`#${this.tooltip}`)
        .style('visibility', 'hidden');
        this.isTooltip = false
  }

  initiateCharts(): void {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg = d3.select(this.stackAreaBarContainer.nativeElement)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr('width', '100%')
      .style('background-color', 'white');
    mySvg.append('text').attr('id', 'noDataMessage' + myClass);
    const defs = mySvg.append('defs');
    defs
      .append('clipPath')
      .attr('id', 'brushClip' + myClass)
      .append('rect')
      .attr('id', 'brushClipRect' + myClass);
    defs.append('clipPath').attr('id', 'alcClip' + myClass)
      .append('rect').attr('id', 'alcClipRect' + myClass);
    const filter = defs
      .append('filter')
      .attr('id', 'drop-shadow')
      .attr('width', 10)
      .attr('height', 24);
    filter
      .append('feGaussianBlur')
      .attr('in', 'SourceAlpha')
      .attr('stdDeviation', 1)
      .attr('result', 'blur');
    filter
      .append('feOffset')
      .attr('in', 'blur')
      .attr('dx', 1)
      .attr('dy', 1)
      .attr('result', 'offsetBlur');
    filter
      .append('feFlood')
      .attr('in', 'offsetBlur')
      .attr('flood-color', '#000000')
      .attr('flood-opacity', 0.4)
      .attr('result', 'offsetColor');
    filter
      .append('feComposite')
      .attr('in', 'offsetColor')
      .attr('in2', 'offsetBlur')
      .attr('operator', 'in')
      .attr('result', 'offsetBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode').attr('in', 'offsetBlur');
    feMerge.append('feMergeNode').attr('in', 'SourceGraphic');
    mySvg
      .append('g')
      .attr('id', 'xAxis' + myClass)
      .attr('class', 'axis' + myClass);
    mySvg
      .append('g')
      .attr('id', 'yAxis' + myClass)
      .attr('class', 'axis' + myClass);
    mySvg.append('line').attr('class', 'partialPeriodLine' + myClass);
    mySvg.append('text').attr('class', 'partialPeriodLineLabel' + myClass);
    mySvg.append('text').attr('id', 'xAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabel' + myClass);
    mySvg.append('g').attr('id', 'legendGroup' + myClass);
    mySvg.append('g').attr('id', 'chartGroup' + myClass);
    mySvg.append('g').attr('id', 'brushGroup' + myClass);
    mySvg.append('g').attr('id', 'brushSelectionGroup' + myClass);
       // legend stuff
    mySvg.append('circle').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowCircleLeft' + myClass);
    mySvg.append('text').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowLeft' + myClass);
    mySvg.append('circle').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowCircleRight' + myClass);
    mySvg.append('text').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowRight' + myClass);
    //tooltip groupss
    mySvg.append('line').attr('class', 'dotLine' + myClass);
    mySvg.append('g').attr('class', 'areaDotsGroup' + myClass);
    mySvg.append('g').attr('class', 'lineDotsGroup' + myClass);
    mySvg.append('g').attr('id', 'sliderGroup' + myClass).attr('class', 'slider' + myClass);
    mySvg
      .append('line')
      .attr('class', 'handleLines' + myClass + ' handleLeftLine1' + myClass);
    mySvg
      .append('line')
      .attr('class', 'handleLines' + myClass + ' handleLeftLine2' + myClass);
    mySvg
      .append('line')
      .attr('class', 'handleLines' + myClass + ' handleRightLine1' + myClass);
    mySvg
      .append('line')
      .attr('class', 'handleLines' + myClass + ' handleRightLine2' + myClass);
      mySvg.append('g').attr('id', 'legendGroup' + myClass);
    mySvg
      .append('circle')
      .attr('class', 'legendCircleBar' + myClass + ' legendItem' + myClass);
    mySvg
      .append('circle')
      .attr('class', 'legendCircleLine' + myClass + ' legendItem' + myClass);
    mySvg
      .append('text')
      .attr('class', 'legendLabelLine' + myClass + ' legendItem' + myClass);
    mySvg
      .append('text')
      .attr('class', 'legendLabelBar' + myClass + ' legendItem' + myClass);
    // legend stuff
    mySvg.append('circle').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowCircleLeft' + myClass);
    mySvg.append('text').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowLeft' + myClass);
    mySvg.append('circle').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowCircleRight' + myClass);
    mySvg.append('text').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowRight' + myClass);
  }

  plotChart(): void {
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);
    const width  = this.isFullscreen==false ? mySvg.node().getBoundingClientRect().width :  window.outerWidth 
    if (this.isFullscreen) {
      this.props.chartHeight = window.outerHeight - 60;
    } else {
      this.props.chartHeight = 500
    }
    const height = this.props.chartHeight;
    mySvg.attr('height', height);
    const timeConverter: any = {
      D: d3.timeDay,
      W: d3.timeWeek,
      M: d3.timeMonth,
      Q: d3.timeMonth,
      Y: d3.timeYear,
      PCQ: d3.timeMonth,
    };
    const tickFormat: any = {
      D: '%d %b %Y',
      W: '%d %b %Y',
      M: '%b %Y',
      Q: '%b %Y',
      Y: '%Y',
      PCQ: '%b, Q%q %Y',
    };
      // Bar Slider
      var barMin:any = undefined;
      var barMax:any = undefined;
      // Line Slider
      var lineMin:any = undefined;
      var lineMax:any = undefined;
    const timePeriod = this.props.dateFormat;
    const xTickFormat: any = d3.timeFormat(tickFormat[timePeriod]);
    let chartData: any = this.chartData;
    // @ts-ignore
    chartData.map((m: any) => (m.date = moment(m[myChart.props.xAxisVar], "YYYY-MM-DD").toDate()));
    const subGroup: any = Array.from(new Set(chartData.map((d: any) => d[myChart.props.subGroupName]))); // Convert Set to Array
    // Create Source Set
    // build source set from group var
    let sourceSet = new Set();
    chartData.forEach((d: any) => sourceSet.add(d[myChart.props.stackVar]));
    // chartData.forEach((d: any) => sourceSet.add(d[myChart.props.stackAreaVar]));
    let sourceSets = Array.from(sourceSet);
    // define colours now we have unique list of groups
    const barColors:any = {}, barColorsLight:any = {};
    if(myChart.props.staticColor){
    Array.from(sourceSet).forEach((d: any, i: number) => {
      barColors[d] = myChart.props.colors[i];
      // barColorsLight[d] = myChart.props.barFill[i];
    });}else{
    sourceSet.forEach((d: any, i: any) => {
      barColors[d] = myChart.props.barFill[i];
      // barColorsLight[d] = myChart.props.barFill[i]
    })}
    //////////////////
    let dateGroup = Array.from(d3.group(chartData, (g: any) => g.date));
    dateGroup = dateGroup.sort((a: any, b: any) => d3.ascending(a[0], b[0]));
    const dateGroupDates: any = []
    let BarChartData: any = [];
    let tooltipData: any = {};
    let barVars: any = new Set();
    let stackVars: any = new Set();
    let dateSet: any = new Set();
    myChart.chartData.forEach((d: any) => {
      barVars.add(d[myChart.props.xAxisVar]);
      dateSet.add(d[myChart.props.xAxisVar]);
      stackVars.add(d[myChart.props.stackVar]);
    });
    // sort and convert dateset
    // dateSet = Array.from(dateSet).map((m: any) => m = new Date(m));
    dateSet = Array.from(dateSet);
    dateSet = dateSet.sort((a: any, b: any) => d3.ascending(a, b));
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Bar Stacking
    // Create Bar
    let stackData: any = [];
    Array.from(barVars).forEach((d: any) => {
      const myData: any = { name: d };
      // Initialize tooltip data if not already initialized
      if (!tooltipData[String(d)]) {
        tooltipData[String(d)] = {};
      }
      tooltipData[String(d)].date = d;
      // Loop through stack variables to create stack data
      Array.from(stackVars).forEach((v: any) => {
        let myValue: any = 0;
        // Find the matching data point
        let fnd = myChart.chartData.find(
          (f: any) =>
            f[myChart.props.xAxisVar] === d && f[myChart.props.stackVar] === v
        );
        if (fnd) {
          myValue = fnd[myChart.props.stackValueVar] || 0;
        }
        myData[v] = myValue;
      });
      stackData.push(myData);
      // Tooltip for each subgroup
      Array.from(subGroup).forEach((s: any) => {
        // Initialize the subgroup if it doesn't exist in tooltipData
        if (!tooltipData[String(d)][s]) {
          tooltipData[String(d)][s] = {};
        }
        Array.from(stackVars).forEach((v: any) => {
          const fnd = myChart.chartData.find(
            (f: any) =>
              f[myChart.props.xAxisVar] === d &&
              f[myChart.props.stackVar] === v &&
              f[myChart.props.subGroupName] === s
          );
          if (fnd) {
            // Assign values to the tooltip data
            tooltipData[String(d)][s][v] =
              fnd[myChart.props.stackValueVar] || 0; // Y-axis value
            tooltipData[String(d)][s]["subGroup"] =
              fnd[myChart.props.subGroupName] || ''; // Subgroup name
            tooltipData[String(d)][s]["date"] = d || ''; // Date
          }
        });
      });
    });
    const stackBar:any = [...new Set(this.chartData.map((m: any) => m[myChart.props.stackVar]))]
    stackData = d3
      .stack()
      .keys(Array.from(stackBar))
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetNone)(stackData);
/////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Area Stacking
    // debugger
    let stackVars_area: any = new Set();
    myChart.chartData.forEach((d: any) => {
      barVars.add(d[myChart.props.xAxisVar]);
      stackVars_area.add(d[myChart.props.stackAreaVar]);
    });
    let AstackData: any = [];
    // Loop through bar variables (X-axis groups)
    Array.from(barVars).forEach((d: any, i: any) => {
      const myData: any = { name: d };
      // Initialize tooltip data for this 'd' if not already initialized
      if (tooltipData[String(d)] === undefined) {
        tooltipData[String(d)] = {};
      }
      tooltipData[String(d)].date = d;
      // Loop through stack area variables to create data
      Array.from(stackVars_area).forEach((v: any) => {
        let myValue: any = 0;
        // Find matching data point for the given `xAxisVar` and `stackAreaVar`
        let fnd = this.chartData.find(
          (f: any) =>
            f[myChart.props.xAxisVar] === d && f[myChart.props.stackAreaVar] === v
        );
        if (fnd) {
          myValue = fnd[myChart.props.stackAreaValueVar] || 0;
        }
        myData[v] = myValue; // Store the value in `myData` for stacking
      });
      AstackData.push(myData);
      // Tooltip logic for each subgroup
      Array.from(subGroup).forEach((s: any) => {
        // Initialize subgroup in tooltip data if not already done
        if (!tooltipData[String(d)][s]) {
          tooltipData[String(d)][s] = {};
        }
        Array.from(stackVars_area).forEach((v: any) => {
          // Find the matching data point for tooltip data
          const fnd = this.chartData.find(
            (f: any) =>
              f[myChart.props.xAxisVar] === d &&
              f[myChart.props.stackAreaVar] === v &&
              f[myChart.props.subGroupName] === s
          );
          if (fnd) {
            // Assign values to tooltip data
            tooltipData[String(d)][s][v] =
              fnd[myChart.props.stackAreaValueVar] || 0; // Y-axis value
            tooltipData[String(d)][s]["subGroup"] =
              fnd[myChart.props.subGroupName] || ''; // Subgroup name
            tooltipData[String(d)][s]["date"] = d || ''; // Date
          }
        });
      });
    });
    // const stackArea:any = [...new Set(this.chartData.map((m: any) => m[myChart.props.stackAreaVar]))]
    // AstackData = d3
    //   .stack()
    //   .keys(Array.from(stackArea))
    //   .order(d3.stackOrderNone)
    //   .offset(d3.stackOffsetNone)(AstackData);
    // Define subgroups and unique kpi names for stacking
    const subgroups: any =  [...new Set(chartData.map((d: any) => d[myChart.props.subGroupName]))].slice(0, 10); // Extract unique subgroups
    const kpiNames: any = [...new Set(chartData.map((d: any) => d[myChart.props.stackVar]))]; // Extract unique KPI names
    //area data
    const tickValues =
      myChart.props.d3AxisFormatting === true ? null : dateGroupDates;
  //  debugger
    const tickCount = myChart.props.d3AxisFormatting === true ? 6 : null;
    // let yMax:any = d3.max(AstackData, (d: any) => d3.max(d, (m: any) => m[1]));
    let yMax:any = d3.max(stackData, (d: any) => d3.max(d, (m: any) => m[1]));
    const yMaxBarStack:any = d3.max(chartData, (d: any) =>  d[myChart.props.stackValueVar])  // Get the maximum 'end' value from each stack
    if(yMaxBarStack>yMax) {yMax=yMaxBarStack}
//     let yMax:any = d3.max(chartData, (d: any) =>  d[myChart.props.stackValueVar])
// console.log(yMax);
 yMax= myChart.props.totalOntop ? yMax*1.1  : yMax
    let xExtent: any = d3.extent(chartData, (d: any) => d.date);
    const xMax = d3.max(chartData, (d: any) => d.date);
    xExtent[0] = timeConverter[timePeriod].offset(xExtent[0], -1);
    xExtent[1] = timeConverter[timePeriod].offset(xExtent[1], 1);
    // --- Calculate Margins Based on Props ---
    // Calculate axis label font sizes for margin calculation
    const xAxisLabelFontSize = myChart.props.xAxisFontSize || 12;
    const yAxisLabelFontSize = myChart.props.yAxisFontSize || 12;
    const legendFontSize = myChart.props.legendFontSize || 12;
    const valueOnBarFontSize = myChart.props.valueOnBarFontSize || 10; // Assuming a prop for value on bar font size
    const totalOnTopFontSize = 10; // Fixed for total labels

    // Calculate approximate text heights based on font size
    const xAxisLabelHeight = myChart.props.xAxisShow ? (xAxisLabelFontSize * 2) : 0; // 1.2 is a rough line height multiplier
    const yAxisLabelWidth = myChart.props.yAxisShow ? (yAxisLabelFontSize * 1.2) : 0; // Approximate width for vertical text

    // Adjust margins based on props and calculated heights
    let margins = {
      left: myChart.props.yAxisShow?75 + yAxisLabelWidth:40, // Add space for Y-axis label width
      right: 40,
      top: 30 , // Add space for total labels on top
      bottom:  10, // Add space for X-axis label height
      brush: myChart.props.showBrush ? 52 : 0, // Use showBrush for conditional margin
      mid:myChart.props.xAxisShow ? (myChart.props.showBrush ? 75 : 0) : 20, // Conditional margin related to brush
      sub: 5,
      axis: 40
    };

    // Adjust subgroup height margin if needed
    if(subgroups.length>1 && myChart.props.subgroups==true) {
      margins.sub = 55
    }else{
      margins.sub = 10
    }
    // if (myChart.props.showBrush === false) { // This is now handled in margin calculation above
    //   margins.brush = 0;
    //   margins.mid = 70;
    //   margins.bottom = 0;
    // }

    if (String(this.props.axisRotation).includes('90')) {
      margins.mid += 15;
    }

    //@ts-ignore
    let startingVisibleRows: any = parseInt((width - margins.left - margins.right) / (subgroups.length+1));
    startingVisibleRows = startingVisibleRows >  (chartData.length) ? chartData.length  : startingVisibleRows;
    const brushStartX = chartData.length === 0 ? 0 : (startingVisibleRows / chartData.length) * (width - margins.left - margins.right);
    const chartHeight = height - margins.top - margins.bottom - margins.brush - margins.mid - margins.sub;
    const brush: any = d3
      .brushX()
      .handleSize(10)
      .extent([[0, 0], [width - margins.left - margins.right, margins.brush]])
      //@ts-ignore
      .on('start brush end', !myChart.props.showBrush ? null : brushed); // Use showBrush here too
    mySvg
      .select('#noDataMessage' + myClass)
      .attr('x', margins.left + (width - margins.left - margins.right) / 2)
      .attr('y', margins.top + (height - margins.top - margins.mid - margins.sub - margins.brush - margins.bottom) / 2)
      .attr('font-family', 'Poppins')
      .attr('fill', '#101D42')
      .attr('font-size', '16px')
      .attr('font-weight', '500')
      .attr('text-anchor', 'middle')
      .text(chartData.length === 0 ? 'There is no data for this time period' : '');
    mySvg.select('.overlay').style('fill', 'transparent');
    mySvg
      .select('#brushClipRect' + myClass)
      .style('width', width - margins.left - margins.right)
      .style('height', chartHeight)
      .attr('transform', 'translate(' + margins.left + ','+margins.top + ')');  
    mySvg
      .select('#alcClipRect' + myClass)
      .style('width', width -  margins.right - margins.left)
      .style('height', margins.brush)
      .attr('transform', 'translate(' + margins.left + ',' + (height-(margins.top*2)-2) + ')');
    const xDomain: any = Array.from(new Set(chartData.map((d: any) => d.date)));
  function roundToNearest(num:any) {
    // Determine the nearest power of 10 based on the number
    const magnitude = Math.pow(10, Math.floor(Math.log10(num)));
    // Round the number up to the next multiple of that magnitude
    return Math.ceil(num / magnitude) * magnitude;
  }
  yMax=roundToNearest(Number(yMax))
    const yScale = d3
      .scaleLinear()
      .domain([0, Number(yMax)])
      .range([Number(height - margins.top - margins.bottom - margins.mid - margins.sub - margins.brush), 0]);
    const yScaleHeight = d3
      .scaleLinear()
      .domain([0, Number(yMax)])
      .range([0, height - margins.top - margins.bottom])
    const yScaleBrush = d3
      .scaleLinear()
      .domain([0, Number(yMax)])
      .range([margins.brush, 0]);
    const xScaleAll: any = d3
      .scaleTime()
      .range([0, width - margins.left - margins.right])
      .domain(xExtent);
    const xScaleSelected: any = d3
      .scaleTime()
      .range([0, width - margins.left - margins.right])
      .domain(xExtent);
    ////////////////
    const extraYs: any = {};
    stackData.forEach((d: any, i: any) => {
    //  debugger
      const myKey = d.key;
      const isLast = i === stackData.length - 1;
      d.map((m: any) => (m.value = m[1] - m[0]));
      d.map((m: any) => (m.height = yScaleHeight(m.value)));
      d.forEach((s: any, index: any) => {
        let myExtraY = 0;
        if (s.height < 2 && s.value > 0) {
          myExtraY = (2 - s.height);
          s.height = 2;
          extraYs[index] =
            extraYs[index] === undefined ? myExtraY : extraYs[index] + myExtraY;
        }
        let myFill = myChart.props.barFill[myKey] || 'red';
        if (myFill === undefined) {
          myFill = myChart.props.stackBarColors[i] || '#000';
          myChart.props.barFill[myKey] = myFill;
          myChart.props.barLabels[myKey] = myKey;
        }
        BarChartData.push({
          date: new Date(s['data'].name),
          start: s[0],
          value: s[1],
          height: s.height,
          fill: myFill,
          extraY: extraYs[index] === undefined ? 0 : -extraYs[index],
          totalValue: s[1],
          borderRadius: isLast ? 2 : 0,
          groupIndex: index,
          stackIndex: i,
          errorType: myKey,
        });
      });
    });
    dateGroup.forEach((d: any, i: any) => {
      dateGroupDates.push(d[0]);
    });
  ///////////////////////////////////////////////  
    // AstackData.forEach((d: any, i: any) => {
    //   const myKey = d.key;
    //   const isLast = i === stackData.length - 1;
    //   d.map((m: any) => (m.value = m[1] - m[0]));
    //   d.map((m: any) => (m.height = yScaleHeight(m.value)));
    //   d.forEach((s: any, index: any) => {
    //     let myExtraY = 0;
    //     if (s.height < 2 && s.value > 0) {
    //       myExtraY = (2 - s.height);
    //       s.height = 2;
    //       extraYs[index] =
    //         extraYs[index] === undefined ? myExtraY : extraYs[index] + myExtraY;
    //     }
    //     let myFill = myChart.props.barFill[myKey];
    //     if (myFill === undefined) {
    //       myFill = myChart.props.stackAreaColors[i] || '#000';
    //       myChart.props.barFill[myKey] = myFill;
    //       myChart.props.barLabels[myKey] = myKey;
    //     }
    //     // AreaChartData.push({
    //     //   date: new Date(s['data'].name),
    //     //   start: s[0],
    //     //   value: s[1],
    //     //   height: s.height,
    //     //   fill: myFill,
    //     //   extraY: extraYs[index] === undefined ? 0 : -extraYs[index],
    //     //   totalValue: s[1],
    //     //   borderRadius: isLast ? 2 : 0,
    //     //   groupIndex: index,
    //     //   stackIndex: i,
    //     //   errorType: myKey,
    //     // });
    //   });
    // });
    // dateGroup.forEach((d: any, i: any) => {
    //   dateGroupDates.push(d[0]);
    // });
    // X Axis Label
    mySvg
      .select('#xAxisLabel' + myClass)
      .attr('visibility', (chartData.length === 0 || myChart.props.xAxisShow === false) ? 'hidden' : 'visible') // Apply X-axis label visibility
      .attr('x', margins.left + (width - margins.left - margins.right) / 2)
      .attr('y', height - margins.bottom - margins.brush - 6)
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#737D88')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.xAxisLabel);
    // Y Axis Label
    mySvg
      .select('#yAxisLabel' + myClass)
      .attr('visibility', (chartData.length === 0 || myChart.props.yAxisShow === false) ? 'hidden' : 'visible') // Apply Y-axis label visibility
      .attr('transform', 'translate(13,' + (margins.top + (height - margins.top - margins.bottom - margins.brush - margins.mid - margins.sub) / 2) + ') rotate(-90)')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#737D88')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.yAxisLabel);

    mySvg
      .select('#xAxis' + myClass)
      .call(
        d3
          .axisBottom(xScaleSelected)
          .tickSizeOuter(0)
          .tickValues(tickValues)
          .ticks(tickCount)
          .tickFormat(xTickFormat)
      )
      .attr('transform', 'translate(' + margins.left + ',' + (margins.top + chartHeight) + ')')
      .attr('visibility', myChart.props.xAxisShow !== false ? 'visible' : 'hidden'); // Control visibility

    // --- Apply Y-Axis Visibility ---
    mySvg
      .select('#yAxis' + myClass)
      .call(
        d3
          .axisLeft(yScale)
          .tickSizeOuter(0)
          .ticks(6)
          .tickFormat((d: any) =>  (yMax>50) ?d3.format(myChart.props.yAxisFormatting)(d):d3.format(".1~f")(d))
        )
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
      .attr('visibility', myChart.props.yAxisShow !== false ? 'visible' : 'hidden'); // Control visibility

    mySvg
      .selectAll('.axis' + myClass + ' path')
      .attr('visibility', chartData.length === 0 ? 'hidden' : (myChart.props.xAxisShow !== false || myChart.props.yAxisShow !== false ? 'visible' : 'hidden')) // Visibility depends on axis settings
      .style('stroke', '#E8EAEE');

    //////////////////////
    // onhover
    // this is the mouseover line, only visible at mouseover, setting key properties
    //   mySvg.select('.dotLine' + myClass)
    //   .attr('visibility', 'hidden')
    //   .attr('pointer-events', 'none')
    //   .attr('stroke', '#A0A0A0')
    //   .attr('fill', '#A0A0A0')
    //   .attr('stroke-width', 2)
    //   .attr('y1', 0)
    //   .attr('y2', height - margins.top - margins.bottom)
    //   .attr('transform',  'translate(' + margins.left + ',' + margins.top + ')');
    const chartGroupData = myChart.props.showBrush === false ? ['chart'] : ['brush', 'chart']; // Use showBrush
    const areaBrush: any =  d3.area()
      .curve(d3.curveLinear)
      .x((d: any) => xScaleAll(new Date(d.data.name)))
      .y0((d: any) =>  yScaleBrush(d[1]))
      .y1( (d: any) =>  yScaleBrush(d[0]))
    const area: any = d3.area()
      .curve(d3.curveLinear)
      .x((d: any) => xScaleSelected(new Date(d.data.name)))
      .y0((d: any) =>  yScale(d[1]))
      .y1( (d: any) =>  yScale(d[0]))
    mySvg
      .select('#brushGroup' + myClass)
      .attr('transform', 'translate('+ margins.left + ',' + (margins.top + chartHeight + margins.mid + margins.sub) +')')
      .call(brush)
      .call(brush.move, [brushStartX, width - margins.left - margins.right]);
    // Remove the brush from the SVG If properties is false 
    if (myChart.props.showBrush === false) { // Use showBrush
      mySvg
        .select('#brushGroup' + myClass)
        .call(brush.move, null)
        .selectAll('*')
        .remove();
    }
    // brush handle lines
    mySvg
      .selectAll('.handleLines' + myClass)
      .attr('visibility', chartData.length === 0 || myChart.props.showBrush === false ? 'hidden' : 'visible') // Use showBrush
      .attr('y1', margins.top + chartHeight + margins.mid + margins.sub + (margins.brush - 12) / 2)
      .attr('y2', margins.top + chartHeight + margins.mid + margins.sub + 12 + (margins.brush - 12) / 2)
      .style('stroke', '#8A98AB')
      .style('stroke-width', '1')
      .attr('transform', 'translate(' + margins.left + ',0)');

////////////////////////////////////////////////////////////////////////////////////////////
    // legend functionality with buttons
    // same on combo/line/area line
    // see line chart for comments/explanations
    let currentLegendSet: any = [];
    currentLegendSet = currentLegendSet.concat(sourceSets);
    let currentLegendItems =  Object.keys(myChart.props.barFill) //JSON.parse(JSON.stringify(currentLegendSet));
    console.log(currentLegendItems)
    let legendIndexLeft = 0;
    let legendIndexRight = currentLegendItems.length;
    const legendWidth = d3.sum(currentLegendItems, (s: any) => measureWidth(s?.toUpperCase(), 12)  + 40)
    mySvg.selectAll('.legendArrowLeftItem' + myClass).attr('visibility', 'hidden');
    if (legendWidth < (width - 60)){
      mySvg.selectAll('.legendArrowRightItem' + myClass).attr('visibility', 'hidden');
    } else {
      currentLegendItems = [];
      let currentWidth = 0;
      currentLegendSet.forEach((d: any, i: any) => {
        currentWidth += (measureWidth(d?.toUpperCase(), 12) + 40);
        if (currentWidth < (width - 60)){
          legendIndexRight = i;
          currentLegendItems.push(d);
        }
      });
    }
    // more legend - see line
    mySvg.select('.legendArrowCircleLeft' + myClass)
      .attr('r', 10)
      .attr('fill', 'transparent')
      .attr('stroke', '#E8EAEE')
      .attr('cursor', 'pointer')
      .attr('cx', 21)
      .attr('cy', 35)
      .on('click', () => {
        legendIndexLeft -= 1;
        legendIndexRight -= 1;
        const myFilteredLegendItems = JSON.parse(JSON.stringify(currentLegendSet));
        currentLegendItems = myFilteredLegendItems.filter((f: any, i: any) => (i >= legendIndexLeft && i <= legendIndexRight));
        drawLegend(currentLegendItems);
        mySvg.selectAll('.legendArrowRightItem' + myClass).attr('visibility', 'visible');
        if (legendIndexLeft === 0){
          mySvg.selectAll('.legendArrowLeftItem' + myClass).attr('visibility', 'hidden');
        }
      });
    // more legend - see line
    mySvg.select('.legendArrowLeft' + myClass)
      .attr('fill', '#1363DF')
      .attr('font-weight', 'bold')
      .attr('font-size', '16')
      .attr('text-anchor', 'middle')
      .attr('pointer-events', 'none')
      .attr('x', 21)
      .attr('y', 35 + 5.5)
      .text('<');
    // more legend - see line
    mySvg.select('.legendArrowCircleRight' + myClass)
      .attr('r', 10)
      .attr('fill', 'transparent')
      .attr('stroke', '#E8EAEE')
      .attr('cursor', 'pointer')
      .attr('cx', width - 21)
      .attr('cy', 35)
      .on('click', () => {
        legendIndexLeft += 1;
        legendIndexRight += 1;
        const myFilteredLegendItems = JSON.parse(JSON.stringify(currentLegendSet));
        currentLegendItems = myFilteredLegendItems.filter((f: any, i: any) => (i >= legendIndexLeft && i <= legendIndexRight));
        drawLegend(currentLegendItems);
        mySvg.selectAll('.legendArrowLeftItem' + myClass).attr('visibility', 'visible');
        if (legendIndexRight === (currentLegendSet.length - 1)){
          mySvg.selectAll('.legendArrowRightItem' + myClass).attr('visibility', 'hidden');
        }
      });
    // more legend - see line
    mySvg.select('.legendArrowRight' + myClass)
      .attr('fill', '#1363DF')
      .attr('font-weight', 'bold')
      .attr('font-size', '16')
      .attr('text-anchor', 'middle')
      .attr('pointer-events', 'none')
      .attr('x', width - 21)
      .attr('y', 35 + 5.5)
      .text('>');
    drawLegend(BarChartData.length === 0 ? [] : currentLegendItems)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    drawChart();
    mySvg
      .selectAll('#brushGroup' + myClass)
      .selectAll('.selection')
      .attr('fill', '#A0A0A0')
      .attr('fill-opacity', '0.2')
      .style('stroke', '#E8EAEE')
      .style('stroke-width', '1');
      mySvg.select('#sliderGroup' + myClass).remove();
      const slider = mySvg.append('g')
      .attr('id', 'sliderGroup' + myClass);
    // // Bar Slider
    // myChart.barMin = myChart.currentMin;
    // myChart.barMax = sbarMax;
    // createRangeSlider('bar', myChart.currentMin, sbarMax);
    // Line Slider 
    if(myChart.props.slider){
    lineMin = myChart.currentMin;
   lineMax = yMax;
    createRangeSlider('bar', myChart.currentMin, yMax);
    }

        function createRangeSlider(id: string, min: number, max: number): void {
           const sliderGroupId = `sliderGroup-${id}`;
           const sliderClass = `${id}-slider`;
           // Remove any existing slider group for this ID
           slider.select(`#${sliderGroupId}`).remove();
           // Create a new slider group
           const sliderGroup = slider.append('g').attr('id', sliderGroupId);
           // Scale setup for the slider
           const scale = d3.scaleLinear()
             .domain([min, max])
             .range(myChart.orientation === 'horizontal' ? [0, yScale.range()[0]] : [yScale.range()[0], 0])
             .clamp(true);
           // Drag event handlers for the min and max handles
           const dragMinHandle = d3.drag().on('drag', (event) => onDragMinHandle( sliderGroup,event, scale, sliderClass, id, min, max));
           const dragMaxHandle = d3.drag().on('drag', (event) => onDragMaxHandle( sliderGroup,event, scale, sliderClass, id, min, max));
           // Create the slider track and inset line
           sliderGroup.append('line')
             .attr('class', `${sliderClass} ${id}-track`)
             .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
             .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
             .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
             .attr('stroke', '#ddd')
             .attr('stroke-width', 1);
           sliderGroup.append('line')
             .attr('class', `${sliderClass} ${id}-track-inset`)
             .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
             .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max + margins.top))
             .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
             .attr('stroke', '#ddd')
             .attr('stroke-width', 1);
           // Tooltip setup
           const tooltip = d3.select('body').append('div')
             .attr('class', 'tooltip')
             .style('position', 'absolute')
             .style('padding', '5px')
             .style('background', '#fff')
             .style('border', '1px solid #ccc')
             .style('border-radius', '4px')
             .style('pointer-events', 'none')
             .style('opacity', 0);
           // Create Min and Max handles with hover and drag functionality
           createSliderHandle( sliderGroup,sliderClass, id, 'min', min, scale, dragMinHandle, tooltip);
           createSliderHandle(sliderGroup,sliderClass, id, 'max', max, scale, dragMaxHandle, tooltip);
         }
         function createSliderHandle(sliderGroup:any,sliderClass: string, id: string, handleType: string, value: number, scale: any, dragHandle: any, tooltip: any): void {
          const circleColor:string = handleType === 'min'? '#718EB6': '#69b3a2';
          // Hover effect layer
          const hoverLayer = sliderGroup.append('circle')
            .attr('class', `${sliderClass} ${id}-${handleType}-hover-layer`)
            .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
            .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
            .attr('r', myChart.handleRadius + 8)
            .attr('fill', circleColor)
            .attr('opacity', 0)
            .attr('pointer-events', 'none');
          const handle = sliderGroup.append('circle')
             .attr('class', `${sliderClass} ${id}-${handleType}-handle`)
             .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
             .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
             .attr('r', myChart.handleRadius)
             .attr('fill', circleColor)
             // Put clicked handle to bottom of DOM group so that it overlaps the other handle
             .on('mousedown', function(){
              handle.raise();
             })
             .call(dragHandle);
           // Handle hover effect
           handle.on('mouseover', function(event: any) {
             hoverLayer.transition().duration(200).attr('opacity', 0.4);  // Show hover layer
             // sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
             //         .attr('stroke-width', 4)
             //         .attr('stroke', '#69b3a2');  // Change color on hover
               //  tooltip
               // .style('opacity', 1)
               // .html(`Max: ${id === 'bar' ? myChart.barMax : myChart.lineMax}`)
               // .style('left', `${event.pageX + 10}px`)
               // .style('top', `${event.pageY - 20}px`);
           })
           .on('mouseout', function() {
             hoverLayer.transition().duration(400).attr('opacity', 0);  // Hide hover layer
             // sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
             //         .attr('stroke-width', 1)
             //         .attr('stroke', '#ddd');  // Revert to original color
                     // tooltip.style('opacity', 0);  // Hide tooltip on mouse out
           })
           .on('mousemove', function(event: any) {
             // Update tooltip position
             //  tooltip
             //   .style('opacity', 1)
             //   .html(`Max: ${id === 'bar' ? myChart.barMax : myChart.lineMax}`)
             //   .style('left', `${event.pageX + 10}px`)
             //   .style('top', `${event.pageY - 20}px`);
             // tooltip.style('left', `${event.pageX + 10}px`).style('top', `${event.pageY - 20}px`);
           });
         }
         function onDragMinHandle(sliderGroup:any,event: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
          // if(myChart.props.chartBrushAndPercents === true){
          //   hideSelectBrush();
          // } 
          const newPos = Math.max(scale(max), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - margins.top);
          const currentMin = Math.round(scale.invert(newPos) - 1);
          // If our drag is greater than the minimum edge and less than the Max handle
          if (currentMin >= min && currentMin <= (id === 'line' ? barMax - 5 : lineMax - 5)) {
            id === 'line'? barMin = currentMin : lineMin = currentMin;
            // update the chart minimum and set the handle to the new position
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'min', newPos);
            updateTrackInset(sliderGroup,scale, sliderClass, id, currentMin, max);
            drawChart();
          }
          // Our drag is less than the minimum edge of the axis
          else if (currentMin < min){
            id === 'line'? barMin = min : lineMin = min;
            // Set the handle position to the minimum edge of the axis
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'min', scale(min));
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, max);
            drawChart();
          }
         }
         function onDragMaxHandle(sliderGroup:any,event: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
          if(myChart.props.chartBrushAndPercents === true){
            // hideSelectBrush();
          } 
          const newPos = Math.min(scale(min), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - margins.top);
          const currentMax = Math.round(scale.invert(newPos) + 1);
          // If our drag is less than the maximum edge and more than the Min handle
          if (currentMax <= max && currentMax >= (id === 'line' ? barMin + 5 : lineMin + 5)) {
            id === 'line'? barMax = currentMax : lineMax = currentMax;
            // update the chart maximum and set the handle to the new position
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'max', newPos);
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, currentMax);
            drawChart();
          }
          // Our drag is more than the maximum edge of the axis
          else if (currentMax > max){
            id === 'line'? barMax = max : lineMax = max;
            // Set the handle position to the maximum edge of the axis
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'max', scale(max));
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, max);
            drawChart();
          }
         }
         function updateTrackInset(sliderGroup:any,scale: any, sliderClass: string, id: string, min: number, max: number): void {
           sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
             .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
             .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max));
         }
         function updateSliderHandlePosition( sliderGroup:any,sliderClass: string, id: string, handleType: string, newPos: number): void {
           sliderGroup.select(`.${sliderClass}.${id}-${handleType}-handle`)
             .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
             sliderGroup.select(`.${sliderClass}.${id}-${handleType}-hover-layer`)
             .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
         }

    function drawLegend(currentLegendItems: any): void {
      // draw legend, similar in all cases, see area line for full explanation
      const legendGroup = mySvg
        .select('#legendGroup' + myClass)
        .selectAll('.legendGroup' + myClass)
        .data(  _.compact(currentLegendItems))
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'legendGroup' + myClass);
          enter.append('circle').attr('class', 'legendCircle');
          enter.append('text').attr('class', 'legendLabel' + myClass);
          return enter;
        });

      // --- Apply Legend Visibility ---
      legendGroup.attr('visibility', myChart.props.legendShow !== false ? 'visible' : 'hidden');

      legendGroup.select('.legendCircle')
        .attr('id', (d: any) => 'circle_legendItem' + d?.replace(/ /g, '') + myClass)
        .attr('cy', 10)
        .attr('fill', (d: any) => myChart.props.barFill[d])
        .attr('r', 4);
      legendGroup.select('.legendLabel' + myClass)
        .attr('id', (d: any) => 'legendItem' + d?.replace(/ /g, '') + myClass)
        .attr('y', 15)
        .attr('fill', myChart.props.legendColor || '#101D42') // Apply legend color
        .attr('font-weight', '500')
        .attr('font-size', '12px') // Apply legend font size
        .attr('font-family', 'Poppins')
        .attr('cursor',  'pointer')
        .text((d: any) => myChart.props.barLabels[d]?.toUpperCase().replace(/_/g, ' '));
      let legendX = 30;
      mySvg.selectAll('.legendLabel' + myClass).each(function(d: any): any {
        //@ts-ignore
        const myObject = this;
        d3.select(myObject).attr('x', legendX);
        mySvg.select('#circle_' + myObject.id).attr('cx', legendX - 8 - 6);
        legendX += (40 + measureWidth(d?.toUpperCase(), myChart.props.legendFontSize)); // Use legend font size for width calculation
      });
      // --- Adjust Legend Positioning if Needed Based on Props ---
      // For example, if legendPosition was 'top', you'd adjust the Y transform here
      // For now, keeping the horizontal centering logic:
      legendGroup.attr('transform', 'translate(' + ((width - legendX + 24) / 2) + ',0)');
    }

    function drawChart(): void {
const yScale = d3
      .scaleLinear()
      .domain([ lineMin || 0 , lineMax || Number(yMax)   ])
      .range([Number(height - margins.top - margins.bottom - margins.mid - margins.sub - margins.brush), 0]);
const yScaleBrush = d3
      .scaleLinear()
      .domain([ lineMin || 0 , lineMax || Number(yMax)   ])
      .range([margins.brush, 0]);
    const yScaleHeight = d3
      .scaleLinear()
      .domain([0, Number(yMax)])
      .range([0, height - margins.top - margins.bottom])
    // Y Axis Scale
    mySvg
      .select('#yAxis' + myClass)
      .call(
        d3
          .axisLeft(yScale)
          .tickSizeOuter(0)
          .ticks(6)
          .tickFormat((d: any) =>  (yMax>50) ?d3.format(myChart.props.yAxisFormatting)(d):d3.format(".1~f")(d))
        )
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
      .attr('visibility', myChart.props.yAxisShow !== false ? 'visible' : 'hidden'); // Control visibility

    mySvg
      .selectAll('.axis' + myClass + ' path')
      .attr('visibility', chartData.length === 0 ? 'hidden' : (myChart.props.xAxisShow !== false || myChart.props.yAxisShow !== false ? 'visible' : 'hidden')) // Visibility depends on axis settings
      .style('stroke', '#E8EAEE');

      // Group data by 'date'
      const groupedData = d3.group(chartData, (d: any) => d.date);
      const maxBarWidth = 14;  // Maximum width for each bar
      const barPadding = 0.4;  // Padding between bars (20% of the bar width)
      // Calculate dynamic range for xScaleSubgroup
      const mainGroupWidth = groupedData.size > 1 ? xScaleSelected(new Date([...groupedData.keys()][1])) - xScaleSelected(new Date([...groupedData.keys()][0])):xScaleSelected(new Date([...groupedData.keys()][0]));
      const numberOfSubgroups = subgroups.length;
      const totalPadding = (mainGroupWidth * 1) * 0.2; // Set 20% of the group width as padding
      const availableWidth =  (mainGroupWidth * 1) - totalPadding;
      // Adjust bar width and include space between bars
      const barWidth = Math.min(availableWidth / (numberOfSubgroups * (1 + barPadding)), maxBarWidth);

      // --- Apply X-Axis Visibility to Grid Lines ---
      mySvg
        .selectAll('#xAxis' + myClass + ' line')
        .attr('y1', '0')
        .attr('y2', -(height - margins.top - margins.bottom - margins.brush - margins.mid - margins.sub))
        .style('stroke', '#F0F3F6')
        .style('stroke-width', 1)
        .attr('visibility', myChart.props.xAxisShow !== false ? 'visible' : 'hidden');

      mySvg
        .selectAll('.axis' + myClass + ' text')
        //@ts-ignore
        .style('font-weight', myChart.props.axisFontWeight)
        .style('font-family', 'Poppins')
        .attr('cursor', 'default')
        //@ts-ignore
        .style('font-size', myChart.props.axisFontSize);

      mySvg
        .selectAll('#xAxis' + myClass + ' text')
        .style('text-anchor', 'middle')
        .style('font-family', 'Poppins')
        .style('font-weight', myChart.props.xAxisBold ? 'bold' : 'normal')
        .style('fill', myChart.props.xAxisColor || '#101D42')
        .style('font-size', myChart.props.xAxisFontSize + 'px')
        .attr('cursor', 'default')
        .attr('dy', margins.sub) // Use the calculated margin
        .attr('transform', '')
        .attr('visibility', myChart.props.xAxisShow !== false ? 'visible' : 'hidden'); // Control visibility

      const xBandwidth = dateGroupDates.length > 1 ? xScaleSelected(dateGroupDates[1]) - xScaleSelected(dateGroupDates[0]) : 0;
      const maxTextWidth = getMaxTextWidth();
      // if (maxTextWidth > xBandwidth - 3) {
        let myFontSize = xBandwidth < myChart.props.axisFontSize + 2 ? xBandwidth - 2 : myChart.props.axisFontSize;
        mySvg
          .selectAll('#xAxis' + myClass + ' text')
          .style('text-anchor', myChart.props.d3AxisFormatting === true ? 'middle' : 'end')
          .attr('dx', 0)
          //@ts-ignore
          .attr('dy', '0.71em') // Keep dy minimal for better alignment
          .attr('transform', function () {
            // const yPosition = additionalSpace + 10; // Adjust to move text without moving axis
            return `translate(0, ${margins.sub-10}) rotate(${myChart.props.d3AxisFormatting === true ? 0 : -45})`; // Use calculated margin
          });
      // }

      function getMaxTextWidth() {
        let maxTextWidth = 0;
        mySvg.selectAll('#xAxis' + myClass + ' text').each(function () {
          //@ts-ignore
          const myNode = d3.select(this).node().getBBox();
          maxTextWidth = Math.max(maxTextWidth, myNode.width);
        });
        return maxTextWidth;
      }

      mySvg
        .selectAll('#yAxis' + myClass + ' line')
        .attr('x1', '0')
        .attr('x2', width - margins.right - margins.left)
        .style('stroke', '#F0F3F6')
        .style('stroke-width', 1)
        .attr('visibility', myChart.props.yAxisShow !== false ? 'visible' : 'hidden');
      
      mySvg
        .selectAll('#yAxis' + myClass + ' text')
        .style('font-family', 'Poppins')
        .style('font-weight', myChart.props.yAxisBold ? 'bold' : 'normal')
        .style('fill', myChart.props.yAxisColor || '#101D42')
        .style('font-size', myChart.props.yAxisFontSize + 'px')
        .attr('cursor', 'default');

      if (myChart.props.showBrush === true) { // Use showBrush
        const handleEastX = +mySvg
          .select('#brushGroup' + myClass)
          .select('.handle--e')
          .attr('x');
        const handleWestX = +mySvg
          .select('#brushGroup' + myClass)
          .select('.handle--w')
          .attr('x');
        mySvg
          .select('.handleLeftLine1' + myClass)
          .attr('x1', handleEastX + 3)
          .attr('x2', handleEastX + 3);
        mySvg
          .select('.handleLeftLine2' + myClass)
          .attr('x1', handleEastX + 7)
          .attr('x2', handleEastX + 7);
        mySvg
          .select('.handleRightLine1' + myClass)
          .attr('x1', handleWestX + 3)
          .attr('x2', handleWestX + 3);
        mySvg
          .select('.handleRightLine2' + myClass)
          .attr('x1', handleWestX + 7)
          .attr('x2', handleWestX + 7);
        mySvg
          .select('#brushGroup' + myClass)
          .selectAll('.handle')
          .attr('fill', 'white')
          .attr('rx', 4)
          .attr('ry', 4)
          .attr('y', (margins.brush - 24) / 2)
          .attr('height', 24)
          .style('filter', 'url(#drop-shadow)');
      }
      mySvg
        .selectAll('.selection')
        .attr('visibility', BarChartData.length === 0 ? 'hidden' : 'visible');
      myChart.currentVisibleData = [chartData, xScaleSelected.domain()];
      ////////////////////////////bar creation end start
      const chartGroup = mySvg
          .select('#chartGroup' + myClass)
          .selectAll('.chartGroup' + myClass)
          .data(chartGroupData)
          .join((group: any) => {
            const enter = group.append('g').attr('class', 'chartGroup' + myClass);
            enter.append('g').attr('class', (d : any) => d === 'brush' ? 'averageLine' + d : 'averageLine' + d);
            enter.append('g').attr('class', (d : any) => d === 'brush' ? 'barsGroup' + d : 'barsGroup' + d);
            return enter;
          });
      chartGroup
        .attr('clip-path', (d: any) => d === 'brush' ? 'url(#alcClip' + myClass + ')' : 'url(#brushClip' + myClass + ')');
      // chartGroup
      //       .select('.averageLinechart')
      //       .attr('transform', (d: any) => 'translate(0,' + (d === 'brush' ? margins.mid + margins.sub + chartHeight : 0) + ')');
      // for brush line chart
      chartGroup
        .select('.averageLinebrush')
        .attr('transform', (d: any) => 'translate(0, 0)');
      // const areaGroup = chartGroup
      //   .select('.averageLinechart')
      //   .selectAll('.areasGroupGroup')
      //   .data(AstackData)
      //   .join((group: any) => {
      //     const enter = group.append('g').attr('class', 'areasGroupGroup');
      //       enter.append('path').attr('class', 'areaGroupItems averageDot');
      //     return enter;   
      //   })
      // for brush
      // const areabrush = chartGroup
      //   .select('.averageLinebrush')
      //   .selectAll('.areasGroupGroup')
      //   .data(AstackData)
      //   .join((group: any) => {
      //     const enter = group.append('g').attr('class', 'areasGroupGroup');
      //       enter.append('path').attr('class', 'areaGroupItems averageDot');
      //     return enter;   
      //   })
      // areaGroup.select('.averageDot')
      //   .attr('d', area)
      //   .attr('fill', (d: any) => d.type === 'brush' ? 'none': myChart.props.barFill[myChart.props.barLabels[d.key]])
      //   .style('stroke-width', 1)
      //   .attr('transform', (d: any) => 'translate(' + margins.left + ',' + (d === 'brush' ? margins.mid + margins.sub + chartHeight + margins.top : margins.top) +')');
      // // For brush chart
      // areabrush.select('.averageDot')
      //   .attr('d',(d:any) => areaBrush(d))
      //   .attr('fill', (d: any) => myChart.props.barFill[myChart.props.barLabels[d.key]])
      //   .style('stroke-width', 1)
      //   .attr('transform', (d: any) => 'translate(' + margins.left + ',' + (margins.mid + margins.sub + chartHeight + margins.top ) + ')');
      /////////////////////////////////
      // bar creation starts
      // chartGroup
      //   // .select('.barsGroup')
      //   .attr('transform', (d: any) => 'translate(0,' + (d === 'brush' ? chartHeight + chartHeight : 0) + ')');
// debugger
      const xScaleSubgroup:any = d3
        .scaleBand()
        .domain(subgroups)
        .range([0, numberOfSubgroups * (barWidth + barPadding * barWidth)]) // Add space between bars
        .padding(barPadding)
        .paddingOuter(0);
      const xScale: any = d3.scaleBand()
      .domain(xDomain)
      .range([0, width - margins.left - margins.right])
      .padding(barPadding)
      .paddingOuter(1.5);
      const xAxis = d3.scaleBand()
        .domain(subGroup)
        .range([0, xScale.bandwidth()])
        .padding(barPadding)
        .paddingOuter(1.5);
      // Prepare data for stacking by restructuring each subgroup's data
      const stackedBarData = Array.from(groupedData, ([date, values]) => {
        const subgroupData = subgroups.map((source:any) => {
          const entry:any = {};
          entry[myChart.props.subGroupName] = source
          kpiNames.forEach((key:any) => {
            const matchingEntry = values.find((v) => v[myChart.props.subGroupName] === source && v[myChart.props.stackVar] === key);
            entry[key] = matchingEntry ? matchingEntry[myChart.props.stackValueVar] : 0;
          });
          entry['date'] = date
          return entry;
        });
        return { date, values: subgroupData };
      });
      // Create the stack generator
      const stack = d3.stack()
        .keys(kpiNames);
      chartGroup
        .select('.barsGroupchart')
        .attr('transform', (d: any) => 'translate(0,' + (d === 'brush' ? margins.mid + margins.sub + chartHeight : 0) + ')');
      chartGroup
        .select('.barsGroupbrush')
        .attr('transform', (d: any) => 'translate(0, 0)');
      // Create the main chart group
      const mainChartGroup = chartGroup
      .select('.barsGroupchart')
      .selectAll('.barsGroupGroupMain')
      .data(stackedBarData)
      .join('g')
      .attr('class', 'barsGroupGroupMain')
      .attr('transform', (d: any) => {
        const subWidth = numberOfSubgroups * (barWidth + barPadding * barWidth);
        return `translate(${xScaleSelected(new Date(d.date)) - subWidth / 2}, ${margins.top})`;
       });

      // // Append bars for each subgroup using stacking
   const barGroups = mainChartGroup
  .selectAll('g.barsStackGroup')
  .data((d: any) => stack(d.values))
  .join('g')
  .attr('class', 'barsStackGroup');
const bars = barGroups
  .selectAll('rect')
  .data((d: any) => {
    return d.map((value: any) => ({
      ...value,
      subgroup: value.data[myChart.props.subGroupName],
      key: d.key,
      height: yScale(value[0]) - yScale(value[1]),
      value: value[1] - value[0]
    }));
  })
  .join('rect')
  .attr('x', (d: any) => xScaleSubgroup(d.subgroup))
  .attr('y', (d: any) => yScale(d[1]))
  .attr('width', Math.abs(barWidth))
  .attr('height', (d: any) => yScale(d[0]) - yScale(d[1]))
  .attr('fill', (d: any, i: any) =>
    myChart.props.staticColor ? myChart.props.colors[i] : myChart.props.barFill[d.key]
  )
        .attr('transform', (d: any) => 'translate(' + margins.left + ',' + (d === 'brush' ? margins.mid + margins.sub + chartHeight + margins.top : 0) +')')
        .on("mousemove", function (event: any, d: any) {
          // get position date by inverting scale
          const positionDate = xScaleSelected.invert(event.offsetX - margins.left);
          // then look at data and get closest date
          let closest: any = dateSet.findIndex((f: any) => new Date(f) >= positionDate);
          if(closest > 0){
            const leftMinutes = d3.timeMinute.count(new Date(dateSet[closest - 1]), positionDate);
            const rightMinutes = Math.abs(d3.timeMinute.count(new Date(dateSet[closest]), positionDate));
            if(leftMinutes < rightMinutes){
              closest -= 1;
            }
          } else if(closest === -1){
            closest = dateSet.length - 1;
          }
          // Highlight the hovered bar
          // mySvg.selectAll('.barsStackGroup rect').attr("opacity", .8);
          // mySvg
          //   .selectAll('.barsStackGroup rect')
          //   .filter((barData: any) => barData.data[myChart.props.subGroupName] === d[myChart.props.subGroupName] && barData.data.date === d.data.date)
          //   .attr('opacity', 1)
          if(myChart.props.subgroups==true){
            mySvg.selectAll('.source-label').attr("font-weight", 500);
            mySvg
              .selectAll('.source-label')
              .filter((barData: any) => barData[myChart.props.subGroupName] === d[myChart.props.subGroupName] && barData.date === d.data.date)
              .attr("font-weight", 600);
          }
          // show tooltip
          const selectedTooltipData = tooltipData[String(dateSet[closest])][d.data[myChart.props.subGroupName]]
          selectedTooltipData['date'] = formatDate(d.data['date'], timePeriod);
          function formatDate(dateString: string, timePeriod: string): string {
            const date = new Date(dateString); // Convert date string to Date object
            const dateFormat = d3.timeFormat(tickFormat[timePeriod]); // Get formatter for the time period
            return dateFormat(date); // Format and return the date
          }
          const filteredData = Object.fromEntries(
            Object.entries(d.data).filter(([key, value]) => value !== 0)
        );
          selectedTooltipData.data=[filteredData]
          // selectedTooltipData['date'] = d3.timeFormat(tickFormat[timePeriod]);
          myChart.showTooltip('clusterStackedBar', selectedTooltipData, event.offsetX, event.offsetY, width, height,barColors);
        })
        .on('mouseout', () => {
          myChart.hideTooltip('clusterStackedBar');
          // mySvg.selectAll('.barsStackGroup rect').attr("opacity", 1);
          mySvg.selectAll('.source-label').attr("font-weight", 500);
        }).on('click', function(event:any, d:any) {
          // get position date by inverting scale
          const positionDate = xScaleSelected.invert(event.offsetX - margins.left);
          // then look at data and get closest date
          let closest: any = dateSet.findIndex((f: any) => new Date(f) >= positionDate);
          if(closest > 0){
            const leftMinutes = d3.timeMinute.count(new Date(dateSet[closest - 1]), positionDate);
            const rightMinutes = Math.abs(d3.timeMinute.count(new Date(dateSet[closest]), positionDate));
            if(leftMinutes < rightMinutes){
              closest -= 1;
            }
          } else if(closest === -1){
            closest = dateSet.length - 1;
          }
          const selectedTooltipData = tooltipData[String(dateSet[closest])][d.data[myChart.props.subGroupName]]
          selectedTooltipData['date'] = formatDate(d.data['date'], timePeriod);
          selectedTooltipData['period'] = dateSet[closest];
          function formatDate(dateString: string, timePeriod: string): string {
            const date = new Date(dateString); // Convert date string to Date object
            const dateFormat = d3.timeFormat(tickFormat[timePeriod]); // Get formatter for the time period
            return dateFormat(date); // Format and return the date
          }
          if (myChart.config?.['barchart_navigation'] == true) {
              myChart.detailChart(selectedTooltipData,barColors)
            }
          // console.log(d);
                  })
        // .transition()
        // .ease(d3.easeCubic)
        // .duration(1000)
        .attr('y', (d: any) => yScale(d[1])) // y-position based on the top of the stack
        .attr('height', (d: any) => yScale(d[0]) - yScale(d[1]))

  //   barGroups
  // .selectAll('text.segment-value')
  // .data((d: any) => {
  //   return d.map((value: any) => ({
  //     ...value,
  //     subgroup: value.data[myChart.props.subGroupName],
  //     key: d.key,
  //     height: yScale(value[0]) - yScale(value[1]),
  //     value: value[1] - value[0]
  //   }));
  // })
  // .join('text')
  // .attr('class', 'segment-value')
  // .attr('x', (d: any) => xScaleSubgroup(d.subgroup) + barWidth / 2 + margins.left)
  // .attr('y', (d: any) => yScale(d[1]) + (yScale(d[0]) - yScale(d[1])) / 2)
  // .attr('text-anchor', 'middle')
  // .attr('dominant-baseline', 'middle')
  // .attr('font-size', '10px')
  // .attr('fill', '#fff')
  // .attr('pointer-events', 'none')
  // .text((d: any) => {
  //   // Only show if segment is tall enough and value > 0
  //   return d.value > 0 && d.height > 12 ? myChart.numbedPipe(d.value) : '';
  // })

  // if (myChart.props.showValue || myChart.props.showPercent) {
  barGroups.selectAll('text.segment-label').remove();
  barGroups.selectAll('g.segment-label-group').remove();
  if( myChart.props.valueOnBar) {
    barGroups
      .selectAll('g.segment-label-group')
      .data((d: any) =>
        d.map((value: any) => {
          const actualValue = value[1] - value[0];
          // Compute total for this subgroup (for %)
          let subgroupTotal = 0;
          kpiNames.forEach((kpi: string) => {
            const entry = value.data;
            subgroupTotal += entry[kpi] || 0;
          });
          const percent = subgroupTotal > 0 ? (actualValue / subgroupTotal) * 100 : 0;
          return {
            ...value,
            subgroup: value.data[myChart.props.subGroupName],
            key: d.key,
            actualValue,
            percent,
            height: yScale(value[0]) - yScale(value[1]),
            subgroupTotal,
          };
        })
      )
      .join('g') // Group for background + text
      .attr('class', 'segment-label-group')
      .each(function(d: any) {
        // Skip if segment too small or value is 0
        if (d.actualValue <= 0 || d.height < 12) return;

        //@ts-ignore
        const g = d3.select(this);
        const parts: any[] = [];

        const decimalPlaces = myChart.props.valueOnBardecimalPlaces !== undefined ? myChart.props.valueOnBardecimalPlaces : 0;

        if (myChart.props.valueOnBarType === 'value') {
          // Format actual value with displayUnits and decimalPlaces
          const displayUnits = myChart.props.valueOnBarDisplayUnits || 'Auto';
          let formattedValue = '';

          if (displayUnits === 'None') {
            formattedValue = d.actualValue.toFixed(decimalPlaces);
          } else if (displayUnits === 'K') {
            formattedValue = (d.actualValue / 1e3).toFixed(decimalPlaces) + 'K';
          } else if (displayUnits === 'M') {
            formattedValue = (d.actualValue / 1e6).toFixed(decimalPlaces) + 'M';
          } else if (displayUnits === 'B') {
            formattedValue = (d.actualValue / 1e9).toFixed(decimalPlaces) + 'B';
          } else if (displayUnits === 'Auto') {
            const abs = Math.abs(d.actualValue);
            if (abs >= 1e9) {
              formattedValue = (d.actualValue / 1e9).toFixed(decimalPlaces) + 'B';
            } else if (abs >= 1e6) {
              formattedValue = (d.actualValue / 1e6).toFixed(decimalPlaces) + 'M';
            } else if (abs >= 1e3) {
              formattedValue = (d.actualValue / 1e3).toFixed(decimalPlaces) + 'K';
            } else {
              formattedValue = d.actualValue.toFixed(decimalPlaces);
            }
          }

          // Clean up trailing zeros
          // if (decimalPlaces > 0) {
          //   formattedValue = formattedValue.replace(/\.?0+([KM B])?$/, '$1');
          // }
          parts.push(formattedValue);
        }

        if (myChart.props.valueOnBarType === 'percentage') {
          // Apply decimal places to percentage
          const formattedPercent = d.percent.toFixed(decimalPlaces);
          // Clean up trailing zeros in decimal part
          const cleanPercent = formattedPercent
          decimalPlaces > 0 
            // ? formattedPercent.replace(/\.?0+$/, '') 
            // : formattedPercent;
          parts.push(`${cleanPercent}%`);
        }

        const textContent = parts.join('\n');
        if (!textContent.trim()) return;

        // Calculate x position
        let xPosition = xScaleSubgroup(d.subgroup);
        const barCenter = xPosition + barWidth / 2;
        let finalX;
        let textAnchor;
        
        switch(myChart.props.valueOnBarposition) {
          case 'left':
            finalX = xPosition;
            textAnchor = 'end'; // Right-align at left edge
            break;
          case 'right':
            finalX = xPosition + barWidth;
            textAnchor = 'start'; // Left-align at right edge
            break;
          case 'center':
          default:
            finalX = barCenter;
            textAnchor = 'middle';
        }

        const yPosition = yScale(d[1]) + (yScale(d[0]) - yScale(d[1])) / 2;
        const fontSize = myChart.props.valueOnBarType === 'value' ? 10 : 6;

        // Create text element first
        const textElement = g.append('text')
          .attr('class', 'segment-label-text')
          .attr('x', finalX)
          .attr('y', yPosition)
          .attr('text-anchor', textAnchor)
          .attr('dominant-baseline', 'middle')
          .attr('font-size', `${fontSize}px`)
          .attr('fill', myChart.props.valueOnBarColor || '#FFF')
          .attr('pointer-events', 'none')
          .attr('transform', `translate(${margins.left}, ${0})`)
          .text(textContent);

        // Add background if enabled
        if (myChart.props.valueOnBarBackground) {
          const bbox = textElement.node()?.getBBox();
          if (bbox) {
            const padding = 2;
            g.insert('rect', '.segment-label-text') // Insert behind text
              .attr('class', 'segment-label-background')
              .attr('x', bbox.x - padding)
              .attr('y', bbox.y - padding)
              .attr('width', bbox.width + padding * 2)
              .attr('height', bbox.height + padding * 2)
              .attr('fill', myChart.props.valueOnBarBackgroundColor || '#000')
              .attr('rx', 2)
              .attr('ry', 2)
              .attr('pointer-events', 'none')
              .attr('transform', `translate(${margins.left}, ${0})`);
          }
        }
      });
  }

// === Compute and Add Total Labels on Top of Each Cluster ===
// mainChartGroup
//   .selectAll('text.cluster-total')
//   .data((d: any) => {
//     // Compute total for this date cluster
//     let total = 0;
//     d.values.forEach((sub: any) => {
//       kpiNames.forEach((kpi: any) => {
//         total += sub[kpi] || 0;
//       });
//     });
//     return [{ date: d.date, total }];
//   })
//   .join('text')
//   .attr('class', 'cluster-total')
//   .attr('x', 0) // centered by transform
//   .attr('y', (d: any) => yScale(d.total) - 8) // 8px above top of bar
//   .attr('text-anchor', 'middle')
//   .attr('font-weight', 'bold')
//   .attr('font-size', '11px')
//   .attr('fill', '#101D42')
//   .attr('pointer-events', 'none')
//   .text((d: any) => myChart.numbedPipe(d.total))
//   .attr('transform', (d: any) => {
//     const subWidth = numberOfSubgroups * (barWidth + barPadding * barWidth);
//     return `translate(${(subWidth / 2)+ margins.left}, 0)`;
//   });

// Add total label on top of each cluster
    mainChartGroup.selectAll('g.subgroup-total-group').remove()
    mainChartGroup.selectAll('rect.subgroup-total-background').remove()
    mainChartGroup.selectAll('text.subgroup-total').remove();
    if (myChart.props.totalOntop) {
      mainChartGroup
        .selectAll('g.subgroup-total-group')
        .data((d: any) => {
          // d = { date, values: [ { subgroup, kpi1, kpi2, ... }, ... ] }
          return d.values.map((subgroupData: any) => {
            // Compute total for this subgroup bar
            let total = 0;
            kpiNames.forEach((kpi: string) => {
              total += subgroupData[kpi] || 0;
            });
            return {
              subgroup: subgroupData[myChart.props.subGroupName],
              total,
              date: d.date
            };
          });
        })
        .join('g')
        .attr('class', 'subgroup-total-group')
        .each(function (d: any) {
          if (d.total <= 0) return;
          //@ts-ignore
          const g = d3.select(this);
          let formattedTotal = '';

          // Determine display unit
          const displayUnits = myChart.props.displayUnits || 'Auto';
          const decimalPlaces = myChart.props.decimalPlaces !== undefined ? myChart.props.decimalPlaces : 0;
console.log('Display Units:', displayUnits, 'Decimal Places:', decimalPlaces);
          if (displayUnits === 'None') {
            // No scaling, just format with decimal places
            formattedTotal = d.total.toFixed(decimalPlaces);
          } else if (displayUnits === 'K') {
            formattedTotal = (d.total / 1e3).toFixed(decimalPlaces) + 'K';
          } else if (displayUnits === 'M') {
            formattedTotal = (d.total / 1e6).toFixed(decimalPlaces) + 'M';
          } else if (displayUnits === 'B') {
            formattedTotal = (d.total / 1e9).toFixed(decimalPlaces) + 'B';
          } else if (displayUnits === 'Auto') {
            // Auto scaling logic
            const abs = Math.abs(d.total);
            if (abs >= 1e9) {
              formattedTotal = (d.total / 1e9).toFixed(decimalPlaces) + 'B';
            } else if (abs >= 1e6) {
              formattedTotal = (d.total / 1e6).toFixed(decimalPlaces) + 'M';
            } else if (abs >= 1e3) {
              formattedTotal = (d.total / 1e3).toFixed(decimalPlaces) + 'K';
            } else {
              formattedTotal = d.total.toFixed(decimalPlaces);
            }
          }

          // Remove unnecessary trailing zeros and decimal point if decimalPlaces > 0 but not needed
          // if (decimalPlaces > 0) {
          //   formattedTotal = formattedTotal.replace(/\.?0+([KM B])?$/, '$1');
          // }

          const textContent = formattedTotal;

          // Calculate positions
          const xPosition = xScaleSubgroup(d.subgroup) + barWidth / 2;
          const yTop = yScale(d.total);
          const yPosition = yTop < 0 ? 0 : yTop;

          // Create text element
          const textElement = g.append('text')
            .attr('class', 'subgroup-total')
            .attr('x', xPosition)
            .attr('y', yPosition)
            .attr('dy', '-0.3em') // Slightly above the top of the bar
            .attr('text-anchor', 'middle')
            .attr('font-weight', 'bold')
            .attr('font-size', '10px')
            .attr('fill', myChart.props.totalOnTopColor || '#101D42')
            .attr('pointer-events', 'none')
            .text(textContent);

          // Add background rectangle if enabled
          if (myChart.props.totalOnTopBackground) {
            const bbox = textElement.node()?.getBBox();
            if (bbox) {
              const padding = 2;
              g.insert('rect', '.subgroup-total') // Insert before the text
                .attr('class', 'subgroup-total-background')
                .attr('x', bbox.x - padding)
                .attr('y', bbox.y - padding)
                .attr('width', bbox.width + padding * 2)
                .attr('height', bbox.height + padding * 2)
                .attr('fill', myChart.props.totalOnTopBackgroundColor || '#FFFFFF')
                .attr('rx', 2)
                .attr('ry', 2)
                .attr('pointer-events', 'none');
            }
          }
        })
        .attr('transform', `translate(${margins.left}, ${0})`);
    }

      // Add labels for each subgroup below the bars// Add text labels for source names
     if( myChart.props.subgroups==true){
      mainChartGroup
        .selectAll('text')
        .data((d: any) => d.values) // Use subgroup data for positioning
        .join('text')
        .attr('class', 'source-label')
        .attr('x', (d: any) => {
          const xSc:any = xScaleSubgroup(d[myChart.props.subGroupName]);
          return xSc + xScaleSubgroup.bandwidth() / 2 
        }) // Center the label
        .attr('y', (d: any) => margins.mid + margins.sub + chartHeight - margins.axis ) // Position slightly above the x-axis
        .attr('text-anchor', 'end') // Center text horizontally
        .text((d: any) => {
          const label = d[myChart.props.subGroupName];
          return subgroups.length > 1 ? label.length > 9 ? `${label.substring(0, 9)}...` : label : '';
        })
        .style('fill', 'black')
        .style('font-family', 'Poppins')
        .attr('cursor', 'default')
        .style('font-size', (barWidth > 10 ? 11 : barWidth + 1) +'px')
        .attr('transform', (d: any) => {
          const xSc:any = xScaleSubgroup(d[myChart.props.subGroupName]);
          return `rotate(-45, ${xSc + xScaleSubgroup.bandwidth() + margins.mid}, ${yScale(0) - 10})`
        });
    }
      // Create the brush group for the brush area
      const brushGroup = chartGroup
        .select('.barsGroupbrush')
        .selectAll('.barsGroupGroupBrush')
        .data(stackedBarData)  // Use the formatted stacked data
        .join((group: any) => {
          const enter = group.append('g')
            .attr('class', 'barsGroupGroupBrush')  // Brush group
            .attr('transform', (d:any) => {
              const balWidth = xAxis.bandwidth() >= barWidth ? (xAxis.bandwidth() - barWidth) : 0;
              return `translate(${xScaleAll(new Date(d.date)) - (xScale.bandwidth()/2) + balWidth}, 0)`; // Center the group
            });
          return enter;
        });
      // Now append bars for the stacked subgroups in the brush area
      brushGroup
        .selectAll('g.brushBarsStackGroup')
        .data((d: any) => stack(d.values))  // Apply stacking to the subgroup data
        .join('g')
        .attr('class', 'brushBarsStackGroup')
        .selectAll('rect')
        .data((d: any) => d.map((value: any) => ({
          ...value,
          [myChart.props.subGroupName]: value.data[myChart.props.subGroupName], 
          key: d.key,  // Key for the stack (e.g., 'New Patients', 'Refill Patients')
          value: value[1] - value[0]  // Calculate the height for the brush bars
        })))
        .join('rect')
        .attr('x', (d: any) => xAxis(d[myChart.props.subGroupName]))  // Use xAxis for positioning subgroups
        .attr('y', (d: any) => yScaleBrush(d[1]))  // y-position based on the top of the stack
        .attr('height', (d: any) => yScaleBrush(d[0]) - yScaleBrush(d[1]))  // Calculate height for stacked brush bars
        .attr('width', Math.max(0, Math.min(barWidth, xAxis.bandwidth())))
        // .attr('width', xAxis.bandwidth() >= barWidth ? barWidth : xAxis.bandwidth() )  // Width for each subgroup
        .attr('fill', (d:any,i:any) =>myChart.props.staticColor ? myChart.props.colors[i] : myChart.props.barFill[d.key])  // Fill color based on the subgroup
        .attr('transform', (d: any) => 'translate(' + margins.left + ',' + (margins.mid + margins.sub + chartHeight + margins.top ) + ')');
    }

    function brushed(event: any): void {
      const selection = event.selection;
         // Check if the bar's x-coordinate falls within the brushed area.
      if(selection !== null) {
        const maxBrushWidth = (startingVisibleRows / chartData.length) * (width - margins.left - margins.right);
        // If the current brush width exceeds the allowed maximum, adjust the right side while maintaining the left
        const brushWidth = selection[1] - selection[0];
        if (brushWidth > maxBrushWidth) {
          const limitedSelection = [selection[0], selection[0] + maxBrushWidth];
          // Check if adjusting right side would go beyond the maximum width of the chart, if so, adjust the left
          if (limitedSelection[1] > width - margins.left - margins.right) {
            limitedSelection[0] = width - margins.left - margins.right - maxBrushWidth;
            limitedSelection[1] = width - margins.left - margins.right;
          }
          mySvg
            .select('#brushGroup' + myClass)
            //@ts-ignore
            .call(brush.move, limitedSelection);
          return; // Exit early as the selection has been reset
        }
        // re-style selection box for the brush selection
        mySvg.selectAll('#brushSelectionGroup' + myClass)
        .selectAll('.selection').attr('class', 'selection lineSelectionBox');
        const xDomain: any = selection.map(xScaleAll.invert);
        const dataRemaining: any = chartData.filter((f: any) => f.date >= xDomain[0] && f.date <= xDomain[1]);
        if (dataRemaining.length < 1) {
          const previousStart = xScaleAll(xScaleSelected.domain()[0]);
          const previousEnd = xScaleAll(xScaleSelected.domain()[1]);
          mySvg
            .select('#brushGroup' + myClass)
            //@ts-ignore
            .call(brush.move, myChart.props.showBrush === false ? null : [previousStart, previousEnd]); // Use showBrush
        } else {
          xScaleSelected.domain(xDomain);
          mySvg
            .select('#xAxis' + myClass)
            // @ts-ignore
            .call(
              d3
                .axisBottom(xScaleSelected)
                .tickSizeOuter(0)
                .tickFormat(xTickFormat)
                .ticks(tickCount)
                .tickValues(tickValues === null ? null : tickValues.filter((f: any) => f >= xDomain[0] && f <= xDomain[1]))
              )
            .attr('transform', 'translate(' + margins.left + ',' + (margins.top + chartHeight) + ')')
            .attr('visibility', myChart.props.xAxisShow !== false ? 'visible' : 'hidden'); // Control visibility after update

          drawChart();
        }
      }
    }

    function measureWidth(myText: any, myFontSize: any): any {
      const context: any = document.createElement('canvas').getContext('2d');
      context.font = myFontSize + 'px sans-serif';
      return context.measureText(myText).width;
    }

    function wrap(text: any, width: any): void {
      text.selectAll('tspan').remove();
      let lineNumber = 0;
      const originalValue = text.text();
      text.each(function (): any {
        // @ts-ignore
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        let word = null;
        let line: any = [];
        const lineHeight = 1.1; // ems
        const dy = 0;
        let tspan = text
          .text(null)
          .append('tspan')
          .attr('x', 0)
          .attr('y', 0)
          .attr('dy', dy + 'em');
        while ((word = words.pop())) {
          line.push(word);
          tspan.text(line.join(' '));
          // @ts-ignore
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            if (word.trim().length > 0) {
              tspan = text
                .append('tspan')
                .attr('x', 0)
                .attr('y', 0)
                .attr('dy', ++lineNumber * lineHeight + dy + 'em')
                .text(word);
            }
          }
        }
      });
      if (lineNumber > 1) {
        text.selectAll('tspan').remove();
        text.attr('id', originalValue);
        text.text(originalValue.substr(0, 5) + '..');
      }
    }
    this.messageEvent.emit(false);
  }

backarrow(){
  this.loader=true
  this.isVisible = true
  this.arrowVisible = false
  setTimeout(() => {
    d3.select('#svg_' + this.divId).remove();
    this.initiateCharts();
    this.plotChart();
    this.loader=false
  }, 200);
}
}